/*************** Stick Nav Top ****************/  
   $(window).scroll(function (e) {
        $el = $('flat-nav-wrapper');
        if ($(this).scrollTop() > 80 && $el.css('position') != 'fixed') {
            $('flat-nav-wrapper').css({ 
                'position': 'fixed', 
                'top': '-10px'/*,
                'left': '50%',
                'margin-left': '-250px' /* container width - image width */
            });
        }
        if ($(this).scrollTop() < 80 && $el.css('position') == 'fixed') {
            $('nav').css({ 'position': 'absolute', 'top': '63px' });
        }
    });
$(document).ready(function(){

  

/*************** Showing/hiding responsive bar ****************/
	$('a.responsive-bar').click(function(){

		if($('div.flat-nav.show-it').length){
			$('div.flat-nav').removeClass('show-it');
		}else{
			$('div.flat-nav').addClass('show-it');
		}
	})
	
/*************** Same height for all collumns ****************/
	$(window).load(function(){
		$('.flat-nav>ul>li').mouseover(function(){

			var x = 0;
			$(this).children('ul.column-based').children('li').each(function(){
				if($(this).height()>x)
				x = $(this).height();
			})
			
			$(this).children('ul.column-based').children('li').each(function(){
				$(this).height(x);
			})
			
			$(this).children('ul.column-based').css('right', '20px')
			
			if($(this).children('ul.column-based').length)
				if($(this).offset().left < $(this).children('ul.column-based').offset().left){
					$(this).children('ul.column-based').css('right', 'auto')
				}
		
			$(this).children('div').css('right', '20px')
		
			if($(this).children('div').length)
				if($(this).offset().left <= $(this).children('div').offset().left){
					$(this).children('div').css('right', 'auto')
				}
				
		})		
		
		$('.flat-nav2>ul>li').mouseover(function(){

			var x = 0;
			$(this).children('ul.column-based').children('li').each(function(){
				if($(this).height()>x)
				x = $(this).height();
			})
			
			$(this).children('ul.column-based').children('li').each(function(){
				$(this).height(x);
			})
			
			$(this).children('ul.column-based').css('right', '20px')
			
			if($(this).children('ul.column-based').length)
				if($(this).offset().left < $(this).children('ul.column-based').offset().left){
					$(this).children('ul.column-based').css('right', 'auto')
				}
		
			$(this).children('div').css('right', '20px')
		
			if($(this).children('div').length)
				if($(this).offset().left <= $(this).children('div').offset().left){
					$(this).children('div').css('right', 'auto')
				}
				
		})		
		
		$('.flat-nav3>ul>li').mouseover(function(){

			var x = 0;
			$(this).children('ul.column-based').children('li').each(function(){
				if($(this).height()>x)
				x = $(this).height();
			})
			
			$(this).children('ul.column-based').children('li').each(function(){
				$(this).height(x);
			})
			
			$(this).children('ul.column-based').css('right', '20px')
			
			if($(this).children('ul.column-based').length)
				if($(this).offset().left < $(this).children('ul.column-based').offset().left){
					$(this).children('ul.column-based').css('right', 'auto')
				}
		
			$(this).children('div').css('right', '20px')
		
			if($(this).children('div').length)
				if($(this).offset().left <= $(this).children('div').offset().left){
					$(this).children('div').css('right', 'auto')
				}
				
		})		
		
		
		$('.flat-nav4>ul>li').mouseover(function(){

			var x = 0;
			$(this).children('ul.column-based').children('li').each(function(){
				if($(this).height()>x)
				x = $(this).height();
			})
			
			$(this).children('ul.column-based').children('li').each(function(){
				$(this).height(x);
			})
			
			$(this).children('ul.column-based').css('right', '20px')
			
			if($(this).children('ul.column-based').length)
				if($(this).offset().left < $(this).children('ul.column-based').offset().left){
					$(this).children('ul.column-based').css('right', 'auto')
				}
		
			$(this).children('div').css('right', '20px')
		
			if($(this).children('div').length)
				if($(this).offset().left <= $(this).children('div').offset().left){
					$(this).children('div').css('right', 'auto')
				}
				
		})
	})
})